import React from 'react'
import styled from 'styled-components'
import CheckCircleOutlineOutlinedIcon from '@mui/icons-material/CheckCircleOutlineOutlined'

const FIELDS = [
  {
    name: 'name',
    label: 'Building name / number',
    placeholder: 'Building name or number'
  },
  { name: 'street', label: 'Address', placeholder: 'Address' },
  { name: 'city', label: 'City', placeholder: 'City' },
  { name: 'postalCode', label: 'Post code', placeholder: 'Post code' },
  {
    name: 'uprn',
    label: 'UPRN (optional)',
    placeholder: 'Building UPRN, if you have it'
  }
]

const ManualBuildingEntry = ({
  values,
  onChange,
  onConfirm,
  onUseMap,
  canContinue,
  completed
}) => (
  <Wrapper>
    <Eyebrow>Manual entry</Eyebrow>
    <Title>Fill in the building address</Title>
    <Text>
      No units are taken from the OS map. After the Building Passport is
      created, use Sync units to find them once they appear in the OS address
      data, or add them manually.
    </Text>

    {FIELDS.map(field => (
      <Field key={field.name}>
        <Label>{field.label}</Label>
        <Input
          name={field.name}
          value={values[field.name] || ''}
          placeholder={field.placeholder}
          inputMode={field.name === 'uprn' ? 'numeric' : undefined}
          onChange={event => onChange(field.name, event.target.value)}
        />
      </Field>
    ))}

    <ConfirmButton type='button' onClick={onConfirm} disabled={!canContinue}>
      <CheckCircleOutlineOutlinedIcon />
      {completed ? 'Save changes' : 'Confirm building'}
    </ConfirmButton>
    <MapLink type='button' onClick={onUseMap}>
      Use the OS map instead
    </MapLink>
  </Wrapper>
)

export default ManualBuildingEntry

const Wrapper = styled.div`
  max-width: 520px;
  padding: 8px 0 12px;
`

const Eyebrow = styled.div`
  margin-bottom: 8px;
  color: ${({ theme }) => theme.colors.secondary};
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.08em;
  text-transform: uppercase;
`

const Title = styled.h2`
  margin: 0;
  color: ${({ theme }) => theme.colors.haiti};
  font-size: 28px;
  font-weight: 700;
  line-height: 1.12;
`

const Text = styled.p`
  margin: 10px 0 6px;
  color: rgba(12, 18, 41, 0.68);
  font-size: 14px;
  font-weight: 500;
  line-height: 1.55;
`

const Field = styled.label`
  display: block;
  margin-top: 13px;
`

const Label = styled.div`
  margin-bottom: 6px;
  color: rgba(12, 18, 41, 0.52);
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.07em;
  text-transform: uppercase;
`

const Input = styled.input`
  box-sizing: border-box;
  width: 100%;
  min-height: 42px;
  border-radius: 8px;
  border: 1px solid rgba(12, 18, 41, 0.14);
  background: #ffffff;
  color: ${({ theme }) => theme.colors.haiti};
  font-size: 13px;
  font-weight: 700;
  outline: none;
  padding: 0 12px;

  &::placeholder {
    color: rgba(12, 18, 41, 0.34);
    font-weight: 600;
  }

  &:focus {
    border-color: ${({ theme }) => theme.colors.secondary};
  }
`

const ConfirmButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  min-height: 48px;
  margin-top: 18px;
  border: 0;
  border-radius: 8px;
  background: ${({ theme }) => theme.colors.secondary};
  color: ${({ theme }) => theme.colors.white};
  font-size: 14px;
  font-weight: 800;
  cursor: pointer;

  svg {
    width: 18px;
    height: 18px;
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.45;
  }
`

const MapLink = styled.button`
  display: block;
  margin: 14px auto 0;
  border: none;
  background: transparent;
  color: ${({ theme }) => theme.colors.secondary};
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  padding: 0;
`
